import Icon from '../components/Icon.vue'

Icon.register({"beer":{"width":448,"height":512,"paths":[{"d":"M368 96H320V56C320 42.7 309.3 32 296 32H24C10.7 32 0 42.7 0 56V456C0 469.3 10.7 480 24 480H296C309.3 480 320 469.3 320 456V413.9L400.6 377.9C429.4 365.1 448 336.4 448 304.9V176C448 131.9 412.1 96 368 96zM384 304.9A16-16 0 0 0 374.5 319.5L320 343.8V160H368C376.8 160 384 167.2 384 176V304.9zM208 384C199.2 384 192 376.8 192 368V144C192 135.2 199.2 128 208 128S224 135.2 224 144V368C224 376.8 216.8 384 208 384zM112 384C103.2 384 96 376.8 96 368V144C96 135.2 103.2 128 112 128S128 135.2 128 144V368C128 376.8 120.8 384 112 384z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/beer.js
// module id = null
// module chunks = 